import React  from 'react';

import './ProfilePage.css';

import ReviewExisting from '../compObjects/ReviewExisting';
import MovieExisting from '../compObjects/MovieExisting';
import Spinner from '../compUtils/Spinner';

import { useDispatch } from 'react-redux'
import { useObjectSelector, getObject } from '../redux/hooks'

import LazyLoad from 'react-lazyload';

import {
  useParams,
} from "react-router-dom";

function MoviePage(props) {
    
    let { id } = useParams();

    const dispatch = useDispatch()

    const reviewsObjectId = "/api/reviews/?param=" +encodeURI(JSON.stringify( {"filter":{"field":"movie","value":id},"order_by":"-date"} ))
    const reviewsSelector = useObjectSelector(reviewsObjectId)
    const reviews = getObject(reviewsObjectId, reviewsSelector, dispatch)
      

    return (
        
      <div class="columns is-variable is-8">
      <div class="column is-one-quarter">
        <MovieExisting movieId={id} />
      </div>
      
      
      {
        reviews() === "UNKNOWN"
          ?
          <Spinner />
          :
          <div class="column">
           
           {reviews().map((review) => (
             <LazyLoad height={200}>
              <ReviewExisting reviewId={review.id} type={"PROFILE"} />
              </LazyLoad>
            ))}
           
          </div>
      }


    </div>
    );
}

export default MoviePage;